import styled from 'styled-components';

export const TabsSC = styled.div`
  .rc-tabs {
    border: none;
  }

  .rc-tabs-nav {
    border-bottom: 2px solid ${({ theme }) => theme.color.border.emphasis};

    .rc-tabs-nav-wrap {
      &::before {
        border: none;
        width: 20px;
        height: 100%;
        background: ${({ theme }) =>
          `linear-gradient(90deg, ${theme.color.gradient.light[0]} 21.04%, ${theme.color.gradient.light[1]} 89.15%)`};
        pointer-events: none;
      }

      &::after {
        border: none;
        width: 20px;
        height: 100%;
        background: ${({ theme }) =>
          `linear-gradient(180deg, ${theme.color.gradient.light[0]} 21.04%, ${theme.color.gradient.light[1]} 89.15%)`};
        pointer-events: none;
      }
    }

    .rc-tabs-nav-operations {
      display: none;
    }
  }

  .rc-tabs-tab {
    height: 48px;
    padding-top: 12px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 10px;

    transition: all 0.2s;

    /* stylelint-disable */
    border-radius: ${({ theme }) =>
      `${theme.radius.extraSmall}px ${theme.radius.extraSmall}px  0 0`};
    /* stylelint-enable */

    opacity: 0.7;

    &.rc-tabs-tab-active {
      opacity: 1;
      color: ${({ theme }) => theme.color.state.active};
    }

    &.rc-tabs-tab-disabled {
      opacity: 0.2;
    }

    &,
    .rc-tabs-tab-btn {
      ${({ theme }) => theme.mappedTypography.h6.strong};
    }

    &:hover:not(.rc-tabs-tab-disabled) {
      background: ${({ theme }) => theme.createOverlayColor('transparent', 'hover', 'light')};
    }
  }

  .rc-tabs-ink-bar {
    height: 2px;
    background: ${({ theme }) => theme.color.state.active};
  }
`;
